export default "__VITE_ASSET__BRx_QkLM__"